module.exports = __webpack_public_path__ + "static/media/tutorial3.ce25672e.jpg";